// @ts-nocheck


import React from 'react';

import { attachedEquipmentTypes } from '../../../lib/enum';
import { Select, Option } from '../../ant/Select';

// Список типов навесного оборудования
export default (props) =>
<Select {...props}>
    {Object.keys(attachedEquipmentTypes).map((key) =>
  <Option value={key} key={key}>
        {attachedEquipmentTypes[key]}
      </Option>
  )}
  </Select>;
